/* MediVerified kit builder: collect packs on the page, show the running total next to the live basket,
   then add the kit (or the starter kit) in one /cart/add.js call and open the drawer the Dawn way. */
(function () {
  if (window.MVKit) return;
  var root = document.querySelector('[data-mv-kit]');
  if (!root) return;

  var CFG = window.MV_CONFIG || {};
  var r = window.routes || {};
  var CART_URL = r.cart_url || '/cart';
  var ADD_URL = (r.cart_add_url || '/cart/add') + '.js';
  var threshold = Number(root.dataset.threshold || CFG.thresholdPence || 10000);
  var delivery = Number(root.dataset.delivery || CFG.deliveryPence || 5000);
  if (delivery > threshold) delivery = threshold;
  var giftProduct = Number(CFG.giftProductId || root.dataset.giftProduct || 0);
  var giftName = CFG.giftName || root.dataset.giftName || 'free 9-slot vial case';
  var giftWorth = CFG.giftWorth || root.dataset.giftWorth || '£14.99';

  var kit = [];
  var cart = null;
  var busy = false;
  var flashTimer;
  var reloadTimer;

  function money(pence) {
    if (window.MV && typeof window.MV.money === 'function') return window.MV.money(pence);
    var s = (Math.round(pence) / 100).toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '£' + s;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function setText(sel, text) { qa(sel).forEach(function (el) { el.textContent = text; }); }

  function cartQualifying() {
    if (!cart) return 0;
    var total = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (it) {
      if (it.sku === 'DELIVERYPLUS' || (it.properties && it.properties._mv_gift)) total -= it.final_line_price || 0;
    });
    return Math.max(0, total);
  }
  function cartCount() {
    if (!cart) return 0;
    var n = 0;
    (cart.items || []).forEach(function (it) { if (it.sku !== 'DELIVERYPLUS' && !(it.properties && it.properties._mv_gift)) n += it.quantity; });
    return n;
  }
  function kitTotal() { return kit.reduce(function (s, l) { return s + l.price * l.qty; }, 0); }
  function kitCount() { return kit.reduce(function (s, l) { return s + l.qty; }, 0); }

  function flash(msg, isError) {
    var el = q('[data-mv-kit-flash]');
    if (!el) return;
    clearTimeout(flashTimer);
    el.textContent = msg;
    el.classList.toggle('mv-kit__flash--error', !!isError);
    el.classList.add('mv-kit__flash--show');
    flashTimer = setTimeout(function () { el.classList.remove('mv-kit__flash--show'); }, isError ? 6000 : 3500);
  }

  function render() {
    var lines = q('[data-mv-kit-lines]');
    var empty = q('[data-mv-kit-empty]');
    var inCart = cartQualifying();
    var total = kitTotal();
    var after = inCart + total;
    var hit = after >= threshold;
    var gap = threshold - after;

    if (lines) {
      lines.innerHTML = kit.map(function (l) {
        return (
          '<li class="mv-kit__line">' +
            '<span class="mv-kit__line-img">' + (l.image ? '<img src="' + esc(l.image) + '" alt="" loading="lazy" width="48" height="48">' : '') + '</span>' +
            '<span class="mv-kit__line-text">' +
              '<span class="mv-kit__line-title">' + esc(l.title) + '</span>' +
              '<span class="mv-kit__line-meta">' + esc(l.pack) + ' · ' + money(l.price) + '</span>' +
            '</span>' +
            '<span class="mv-kit__line-qty">' +
              '<button type="button" class="mv-kit__qty-btn" data-mv-kit-dec="' + l.id + '" aria-label="Remove one ' + esc(l.title) + '">&minus;</button>' +
              '<span class="mv-kit__qty-n" aria-label="Quantity">' + l.qty + '</span>' +
              '<button type="button" class="mv-kit__qty-btn" data-mv-kit-inc="' + l.id + '" aria-label="Add one more ' + esc(l.title) + '">+</button>' +
            '</span>' +
            '<span class="mv-kit__line-price">' + money(l.price * l.qty) + '</span>' +
          '</li>'
        );
      }).join('');
    }
    if (empty) empty.hidden = kit.length > 0;

    var cartRow = q('[data-mv-kit-row-cart]');
    if (cartRow) cartRow.hidden = !(cart && cart.item_count);
    setText('[data-mv-kit-cart]', money(inCart));
    setText('[data-mv-kit-total]', money(total));
    setText('[data-mv-kit-after]', money(after));

    var status = q('[data-mv-kit-status]');
    if (status) {
      status.textContent = hit ? 'Reward unlocked' : money(gap) + ' to the reward';
      status.classList.toggle('mv-kit__status--hit', hit);
    }
    var nudge = q('[data-mv-kit-nudge]');
    if (nudge) {
      if (!kit.length && !inCart) nudge.textContent = 'Spend ' + money(delivery) + ' for free Standard delivery, or ' + money(threshold) + ' for free delivery and a ' + giftName + ' (worth ' + giftWorth + ').';
      else if (hit) nudge.textContent = (kit.length ? 'Add this kit and your basket unlocks ' : 'Your basket has unlocked ') + 'free Standard delivery and the ' + giftName + '.';
      else if (after >= delivery) nudge.textContent = 'Free Standard delivery is covered. Add ' + money(gap) + ' more for the ' + giftName + ' (worth ' + giftWorth + ').';
      else nudge.textContent = 'Add ' + money(delivery - after) + ' more for free Standard delivery, ' + money(gap) + ' for the ' + giftName + ' too.';
      nudge.classList.toggle('mv-kit__nudge--hit', hit);
    }

    var label = kit.length ? 'Add kit to basket · ' + money(total) : 'Add kit to basket';
    qa('[data-mv-kit-add-all]').forEach(function (b) { b.disabled = busy || !kit.length; b.textContent = label; });

    var bar = q('[data-mv-kit-bar]');
    if (bar) {
      bar.hidden = !kit.length;
      setText('[data-mv-kit-bar-total]', money(total));
      setText('[data-mv-kit-bar-note]', kitCount() + (kitCount() === 1 ? ' pack' : ' packs') + ' in your kit · basket after ' + money(after));
    }

    qa('[data-mv-kit-card]').forEach(function (card) {
      var pid = Number(card.dataset.productId);
      var n = kit.filter(function (l) { return l.productId === pid; }).reduce(function (s, l) { return s + l.qty; }, 0);
      var badge = card.querySelector('[data-mv-kit-count]');
      if (badge) { badge.hidden = !n; badge.textContent = 'In your kit ×' + n; }
      card.classList.toggle('mv-kit__card--on', n > 0);
    });
  }

  function loadCart() {
    return fetch(CART_URL + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (c) { cart = c; render(); })
      .catch(function () { render(); });
  }

  function addLine(line) {
    var existing = kit.filter(function (l) { return l.id === line.id; })[0];
    if (existing) existing.qty += 1; else kit.push(line);
    render();
    flash(line.title + ' (' + line.pack + ') added to your kit.');
  }
  function changeQty(id, delta) {
    kit = kit.map(function (l) { return l.id === id ? Object.assign({}, l, { qty: l.qty + delta }) : l; })
      .filter(function (l) { return l.qty > 0; });
    render();
  }

  function post(body) {
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) { if (!res.ok) throw json; return json; });
    });
  }

  function openDrawer(response) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && response.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(response);
      return true;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && response.sections && response.sections['cart-icon-bubble']) {
      var doc = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
      var fresh = doc.querySelector('.shopify-section');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }
    return false;
  }

  function addToCart(items, successMsg, buttons) {
    if (busy || !items.length) return;
    busy = true;
    var labels = buttons.map(function (b) { return b.textContent; });
    buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = 'Adding…'; });
    post({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      .then(function (res) {
        var opened = openDrawer(res);
        kit = [];
        document.dispatchEvent(new CustomEvent('mv:cart-changed'));
        flash(successMsg + (opened ? '' : ' View your basket to check out.'));
        return loadCart();
      })
      .catch(function (err) {
        var msg = err && (err.description || err.message);
        flash(typeof msg === 'string' ? msg : 'Sorry, that could not be added. Please try again.', true);
      })
      .then(function () {
        busy = false;
        buttons.forEach(function (b, i) { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = labels[i]; });
        render();
      });
  }

  root.addEventListener('click', function (event) {
    var t = event.target;
    var add = t.closest('[data-mv-kit-add]');
    if (add && root.contains(add)) {
      var card = add.closest('[data-mv-kit-card]');
      if (!card) return;
      var select = card.querySelector('[data-mv-kit-select]');
      var hidden = card.querySelector('[data-mv-kit-variant]');
      var src = select ? select.options[select.selectedIndex] : hidden;
      if (!src) return;
      addLine({
        id: Number(src.value),
        productId: Number(card.dataset.productId),
        qty: 1,
        title: add.dataset.title || '',
        pack: src.dataset.pack || '',
        price: Number(src.dataset.price || 0),
        image: add.dataset.image || ''
      });
      return;
    }
    var inc = t.closest('[data-mv-kit-inc]');
    if (inc) { changeQty(Number(inc.dataset.mvKitInc), 1); return; }
    var dec = t.closest('[data-mv-kit-dec]');
    if (dec) { changeQty(Number(dec.dataset.mvKitDec), -1); return; }

    var all = t.closest('[data-mv-kit-add-all]');
    if (all) {
      addToCart(
        kit.map(function (l) { return { id: l.id, quantity: l.qty }; }),
        'Your kit is in the basket.',
        qa('[data-mv-kit-add-all]')
      );
      return;
    }
    var starter = t.closest('[data-mv-kit-starter]');
    if (starter) {
      var data = [];
      try { data = JSON.parse((q('[data-mv-kit-starter-data]') || {}).textContent || '[]'); } catch (e) { data = []; }
      addToCart(
        data.map(function (l) { return { id: l.id, quantity: l.quantity || 1 }; }),
        'Starter kit added to your basket.',
        [starter]
      );
    }
  });

  function scheduleReload() { clearTimeout(reloadTimer); reloadTimer = setTimeout(loadCart, 300); }
  document.addEventListener('mv:cart-changed', scheduleReload);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleReload);

  render();
  loadCart();
  window.MVKit = { reload: loadCart };
})();
